/**
 * Logotipo «La curva» (arquitectura 2.16): cuadro redondeado con la S dibujada como curva de
 * carretera y su trazo central en naranja señal, junto al nombre en minúsculas con letra ancha.
 * El cuadro toma `currentColor`; la S toma `--ui-logo-contra` (por omisión, el fondo).
 */
export const TRAZO_S = 'M44 14H24a9 9 0 0 0 0 18h16a9 9 0 0 1 0 18H20';
export const TRAZO_CENTRO = 'M28 32h8';

export function Simbolo({ tamano = 32, titulo }: { tamano?: number; titulo?: string }) {
  return (
    <svg
      className="ui-simbolo"
      viewBox="0 0 64 64"
      width={tamano}
      height={tamano}
      role={titulo ? 'img' : undefined}
      aria-hidden={titulo ? undefined : true}
      aria-label={titulo}
    >
      <rect width="64" height="64" rx="14" fill="currentColor" />
      <path
        d={TRAZO_S}
        fill="none"
        stroke="var(--ui-logo-contra, var(--ui-fondo))"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <path
        d={TRAZO_CENTRO}
        stroke="var(--ui-acento-marca)"
        strokeWidth="7"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Símbolo + «siniestrados». `tamano` es la altura del símbolo en px. */
export function Logotipo({ tamano = 28, className }: { tamano?: number; className?: string }) {
  return (
    <span
      className={`ui-logotipo${className ? ` ${className}` : ''}`}
      style={{ fontSize: tamano * 0.68 }}
    >
      <Simbolo tamano={tamano} />
      <span className="ui-logotipo-nombre">siniestrados</span>
    </span>
  );
}
